import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 126px;
  background: #fff;
  width: 100%;
  font-size: 0.9rem;
  line-height: 1.5;
  padding: 30px;

  @media screen and (max-width: 767px) {
    min-height: 170px;
    padding: 20px;
  }
`;

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 1000px) {
    min-width: 90%;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const CompanyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

const Content = styled.div`
  font-size: 0.9rem;
  line-height: 1.6;

  @media screen and (max-width: 767px) {
    font-size: 0.8rem;
    line-height: 1.8;
  }
`;

const Spacer = styled.span`
  margin: 0 10px;
  
  @media screen and (min-width: 768px) and (max-width: 1000px) {
    margin: 0 5px;
  }

  @media screen and (max-width: 767px) {
    margin: 0;
  }
`;

const Break = styled.br`
  display: none;

  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const MediaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  
  a {
    cursor: pointer;
    width: 50px;
    height: 50px;
    border-radius: 50%;

    &:hover, &:focus {
      box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.2);
    }

    &:not(:last-child) {
      margin-right: 20px;
    }

    img {
      width: 50px;
      height: 50px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 900px) {
    a {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  @media screen and (max-width: 767px) {
    margin: 20px;

    a {
      width: 40px;
      height: 40px;
      
      &:not(:last-child) {
        margin-right: 30px;
      }

      img {
        &:not(:last-child) {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
`;

export {
  Wrapper,
  CenterWrapper,
  CompanyWrapper,
  Content,
  Spacer,
  Break,
  MediaWrapper,
};
